<template>
    <div class="w100 bgGrey">
        <article class="infor-detail-box">
            <div class="grid-content bgWhite p20">
                <h1 style="word-break: break-all;">{{ detail_info.length > 0 ? detail_info[0]['the_title'] : '' }}</h1>
                <div class="content-right" style="margin-top: 15px;">
                    <p class="fontLight">编辑：{{ detail_info.length > 0 ? detail_info[0]['oper_man'] : '未知' }}&nbsp;&nbsp;&nbsp;&nbsp;来源: {{ detail_info.length > 0 ? detail_info[0]['sources'] : '未知' }}&nbsp;&nbsp;&nbsp;&nbsp;日期：{{ detail_info.length > 0 ? detail_info[0]['create_date'].substr(0, 10) : '' }}</p>
                    <p class="mw-modular-box font14 fontLight">文章标签<span class="tag pointer" v-for="(table, tableI) in detail_info[0].the_table.split(',')" :key="tableI">{{ table }}</span></p>
                    <div class="mw-modular-box" id="qlEditorBox">
                        <div class="mw-editor-box ql-editor" style="padding: 5px;"></div>
                    </div>
                    <small class="fontLighter">本文信息仅供参考，未经许可，不可转载。</small>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import { baseUrl } from '../../assets/js/common'
export default {
    name: 'DetailPhone',
    components: {  },
    data () {
        return {
            // qqPic: require('../../assets/images/logo.png'),
            // qrcode: '',
            id: '',
            // detail_page: {
            //     last: {},
            //     next: {}
            // },
            detail_info: {},
            isBefore: true
            // share_info: {},
            // isCollect: false,
            // wxCodeDialog: false,
            // consult_sel_all: [],
            // label_list: []
        }
    },
    mounted () {
        // 初始化内容
        // console.log(window.location)
        this.id = this.$route.params.id;
        this.init();
    },
    methods: {
        init () {
            this.getInfos();
            this.consultFollow();
            // this.getTGraphicSel();
            // this.tNewsConsultSelAll();
        },

        // 记录点击量
        consultFollow () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/consult_follow`,
                data: {
                    primary_id: this.id,
                    follow: 'Y'
                },
                type: 'post',
                dataType: 'json',
                success: (res) => {},
                error: () => {}
            })
        },

        //根据id 获取页面详情
        getTGraphicSel () {
            const self = this;
             const type = self.isBefore ? 1 : 2;
            $.ajax({
                url: `${baseUrl.service}/api_v3/t_graphic_sel/${self.id}`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        if (type == 1) {
                            $('.mw-editor-box').html(res.data.graphic);
                        } else {
                            $.ajax({
                                url: `${baseUrl.informationFF}/API_V1/NEWS/newsdata?NEWS_ID=${self.id}`,
                                data: {},
                                type: 'get',
                                dataType: 'json',
                                success: (res_1) => {
                                    if (res_1.code == 'ok') {
                                        $('.mw-editor-box').html(res_1.data);
                                    } else {
                                        self.$message.error(res_1.message);
                                    }
                                },
                                error: () => {
                                    // self.$message.error('未获取到详情信息')
                                }
                            })
                        }
                        $('#qlEditorBox').height($('.mw-editor-box').height() + 40);
                    } else {
                        self.$message.error(res.message);
                    }
                },
                error: () => {
                    // self.$message.error('未获取到详情信息')
                }
            })
        },

        // 获取信息
        getInfos () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/t_news_consult_sel_primary?primary_id=${self.id}`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        self.detail_info = res.data;
                        self.compareDate(res.data[0].create_date)
                        self.getTGraphicSel();
                    } else {
                        self.$message.error(res.message);
                    }
                },
                error: () => {
                    // self.$message.error('未获取到详情信息')
                }
            })
        },
        // 对比日期，4月1日之前的用t_graphic_sel, 之后的用newsdata
        compareDate (_date) {
            const times = new Date('2020-04-07').getTime();
            const dateTimes = new Date(_date).getTime();
            if (times >= dateTimes) {
                this.isBefore = true;
            } else {
                this.isBefore = false;
            }
        }

    },
}
</script>

<style scoped>
    .infor-detail-box .tag { border: 1px solid #eee; border-radius: 15px; padding: 1px 10px; color: #a30000; display: inline-block; margin-left: 10px; }
</style>